import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'thousandSuffix',
  standalone: false,
})
export class ThousandSuffixPipe implements PipeTransform {
  transform(input: any, args?: any): any {
    // Short-scale economic notation, deliberately not the SI metric table:
    // a billion is 'B' (billion), not 'G' (Giga).
    const suffixes = ['K', 'M', 'B', 'T', 'Qa', 'Qi'];
    const oneBillion = 1_000_000_000;
    let exp;
    if (input && typeof input === 'string' && input.endsWith('%')) {
      return input;
    }

    if (this.isNotNumber(input)) {
      return input;
    }

    input = Math.trunc(input);
    if (input < 1000) {
      return input;
    }

    exp = Math.floor(Math.log(input) / Math.log(1000));
    // Below a billion, keep the long-standing behaviour of dropping the decimal.
    // From a billion upward, honour the caller's decimals so large amounts are
    // not understated (1.23 billion must not render as "1B").
    if (input < oneBillion && ((input > 10000 && input < 1000000) || input > 10000000)) {
      args = 0;
    }
    return (input / Math.pow(1000, exp)).toFixed(args) + suffixes[exp - 1];
  }

  private isNotNumber(input): boolean {
    return Number.isNaN(parseFloat(input));
  }
}
